import React from "react";
import Highcharts from "highcharts/highstock";
import HighchartsReact  from "highcharts-react-official";
import NoDataToDisplay from 'highcharts/modules/no-data-to-display';
import Exporting from "highcharts/modules/exporting";
import OfflineExporting from 'highcharts/modules/offline-exporting';
import { getMonthDateYearTimePeriod } from 'helpers/DateUtil'

Exporting(Highcharts);
OfflineExporting(Highcharts)
NoDataToDisplay(Highcharts);

class Pie extends React.Component {
  render() {
    const {
      title,
      data,
      additionalOptions
    } = this.props

    const options = {
      chart: {
        type: "pie",
        spacingBottom: 30
      },
      title: {
        text: title
      },
      series: [
        {
          data: data
        }
      ],
      tooltip: {
        pointFormat: '<b>{point.percentage:.1f}%</b>'
      },
      accessibility: {
        point: {
          valueSuffix: '%'
        }
      },
      plotOptions: {
        pie: {
          colors: ['#76b900', "#7cb5ec", "#434348", "#90ed7d", "#f7a35c", "#8085e9", "#f15c80", "#e4d354", "#2b908f", "#f45b5b", "#91e8e1"],
          dataLabels: {
            enabled: true,
            format: '<b>{point.name}</b>: {point.y} '
          }
        }
      },
      credits: {
        text: `Source: Fulcrum (nvidia.com) <br /> ${getMonthDateYearTimePeriod(new Date())}`,
        href: false,
        style: {
          cursor: 'default'
        },
        position: {
          align: 'right',
          verticalAlign: 'bottom',
          y: -20
        }
      },
      lang: {
        noData: "No data available"
      },
      exporting: {
        fallbackToExportServer: false,
        buttons: {
          contextButton: {
            menuItems: ['downloadPNG','downloadJPEG']
          }
        }
      }
    };

    if (additionalOptions) {
      Object.assign(options, additionalOptions); 
    }

    return (
      <React.Fragment>
        <HighchartsReact highcharts={Highcharts} options={options}/>
      </React.Fragment>
    );
  }
}


export default Pie
